var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{class:[_vm.centered ? 'version-centered' : 'version-main'],attrs:{"color":"transparent"}},[_c('small',{class:['version-color']},[_vm._v(" v"+_vm._s(_vm.app_version.version)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }